import React from "react";
import WineSearchResults from "../../components/layout/BaseWine/WineSearchResults";
import Header from "../../components/layout/Header/Header";
import Layout from "../../components/layout/Layout/Layout";
import { formatTitle } from "../../utils/helper";
import Head from "next/head";
import {
  baseWineSearch,
  getWines,
  producerSearch,
  wineVintageSearch,
} from "../../lib/wineRequests";
import {
  convertFilterParams,
  extractLabelAndYear,
  formatFilterParams,
  yearRegex,
} from "../../utils/wine";
import { withUserSSR } from "../../utils/withUserSSR";

interface IWinesPageProps {
  initialWines: any;
  errorLoading?: string;
}

export default function WinesPage({ initialWines, errorLoading }: IWinesPageProps ) {
  return (
    <Layout disableMeta={true}>
      <Head>
        <title>{formatTitle("Tasting Notes Index")}</title>
        <meta name="description" content="Explore tasting notes and reviews on Vinous." />
        <meta name="keywords" content="tasting notes, wine reviews, Vinous tasting notes" />
        <link rel="canonical" href="https://vinous.com/wines" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="google-translate-customization"
          content="bc9c404857e6094b-bd2091ef6a1aacc6-g5523c9461670c8e8-21"
        />
      </Head>
      <Header />
      <WineSearchResults initialWines={initialWines} errorLoading={errorLoading || ""} />
    </Layout>
  );
}

export const getServerSideProps = withUserSSR(async (context) => { //GetServerSideProps = async ({ query }) => {
  const query = context?.query;
  const filters = query.filters as string;
  const objFilter = convertFilterParams(filters);
  // Forward the visitor's session so subscribers get full tasting notes.
  const cookie = context.req.headers.cookie || "";
  try {
    const { term, vintage } = extractLabelAndYear(query.term as string);
    
    const params = {
      term: term || "*",
      vintage: vintage ? parseInt(vintage) : null,
      order: query.sort || "",
      order_type: query.sortDirection || "desc",
      page: query.page || 1,
      per_page: query.per_page || 25,
      ...formatFilterParams(objFilter),
    };

    const { data: initialWines } =
      query?.displayType === "reviews"
        ? await getWines(params, cookie)
        : query?.displayType === "baseWine"
        ? await baseWineSearch(params, cookie)
        : query?.displayType === "wineVintage"
        ? await wineVintageSearch(params, cookie)
        : query?.displayType === "producer"
        ? await producerSearch(params, cookie)
        : await getWines(params, cookie);
    return {
      props: {
        initialWines,
      },
    };
  } catch (error) {
    if (error?.data?.error) {
      return {
        props: {
          initialWines: null,
          errorLoading: `Failed to fetch wines: ${error.data.error}`,
        },
      };
    }
    
    return {
      props: {
        initialWines: null,
        errorLoading: `Failed to fetch wines: ${error.message}`,
      },
    };
  }
});
